module.exports = __webpack_public_path__ + "static/media/map_preview_animation.1762bb0a.gif";